import { createContext } from 'react'

import type { RiaCitatorSection } from '@/analytics/enums/ria.enums'
import type { CaseLawReferenceTab } from '@/citator/schema/case-law-reference-tab'
import type { AgentV2Reference } from '@/agent-v2/store/schemas'

export type AgentV2ReferenceOpenOverride = (
  reference: AgentV2Reference,
  turnId?: string,
  options?: { defaultTab?: CaseLawReferenceTab; defaultOpenSection?: RiaCitatorSection }
) => 'panel' | 'tab' | false

/**
 * Optional host override for embedded surfaces such as the Outlook task pane.
 * The normal web application leaves this null and keeps the in-app viewer behavior.
 */
export const AgentV2ReferenceOpenContext = createContext<AgentV2ReferenceOpenOverride | null>(null)
